import { useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * ShiftCover365 brand mark.
 * - /logo.png is the transparent icon-only mark
 * - Wordmark is rendered as text alongside (typography-led, SaaS-style)
 * - Sizes are tight and intentionally favour the wordmark over the icon
 * - linkTo defaults to "/"; pass null to render as static
 */
const ICON_SIZE = {
  xs: 'h-5 w-5',
  sm: 'h-6 w-6',
  md: 'h-7 w-7',
  lg: 'h-9 w-9',
  xl: 'h-12 w-12',
};

const TEXT_SIZE = {
  xs: 'text-sm',
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-xl',
  xl: 'text-2xl',
};

export const Logo = ({
  size = 'md',
  showWordmark = true,
  linkTo = '/',
  className = '',
  wordmarkClassName = '',
  variant = 'auto', // 'auto' | 'light' (navy bg) | 'dark' (light bg)
}) => {
  const [imgFailed, setImgFailed] = useState(false);
  const iconClass = ICON_SIZE[size] || ICON_SIZE.md;
  const textClass = TEXT_SIZE[size] || TEXT_SIZE.md;

  const wordmarkColor =
    variant === 'light'
      ? 'text-white'
      : variant === 'dark'
      ? 'text-[#0f1b3d]'
      : 'text-inherit';

  const content = (
    <span
      className={`inline-flex items-center gap-2 leading-none ${className}`}
      data-testid="brand-logo"
    >
      {!imgFailed && (
        <img
          src="/logo.png"
          alt="ShiftCover365"
          className={`${iconClass} object-contain shrink-0 select-none ${variant === 'light' ? 'logo-light-halo' : ''}`}
          draggable={false}
          onError={() => setImgFailed(true)}
          data-testid="brand-logo-img"
        />
      )}
      {showWordmark && (
        <span
          className={`font-bold font-['Public_Sans'] tracking-tight ${textClass} ${wordmarkColor} ${wordmarkClassName}`}
        >
          ShiftCover<span className="text-[#DA291C]">365</span>
        </span>
      )}
    </span>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className="group inline-flex items-center cursor-pointer transition-opacity duration-150 hover:opacity-80"
        data-testid="brand-logo-link"
      >
        {content}
      </Link>
    );
  }
  return content;
};

export default Logo;
